import Flickity from 'flickity';

export default class Horizontal {
  constructor() {
    const $els = document.querySelectorAll('.js-horizontal');
    $els.forEach($el => new ReadMore($el));
  }
}

class ReadMore {
  constructor($el) {
    this.$text = $el.querySelector('.js-text');
    this.$readMore = $el.querySelector('.js-read-more');
    this.$readLess = $el.querySelector('.js-read-less');

    this.$readMore.addEventListener('click', e => {
      e.preventDefault();

      this.$text.ariaExpanded = true;
      // this.$readMore.classList.add('hidden');
      // this.$readLess.classList.remove('hidden');
    })

    this.$readLess.addEventListener('click', e => {
      e.preventDefault();

      this.$text.ariaExpanded = false;
    });

  }
}
